import {HostMaps, replaceAutoHost} from 'hiya-common/src/utils/host/AutoHost'
import deepGet from './deepGet'
import _map from "lodash/map";

export const isZY = (userAgent) =>
  /inapp/i.test(userAgent || navigator.userAgent)

function padStart(originStr,targetLen,padStr) {
  let targetLength = Number(targetLen)
  const originString = String(originStr)
  const padString = String(typeof padStr !== 'undefined' ? padStr : ' ')

  if(originString.length > targetLength) {
    return String(originString)
  }

  targetLength -= originString.length

  const padding = new Array(
    Math.ceil(targetLength / padString.length) + 1
  ).join(padString)

  return padding.slice(0,targetLength) + originString
}

function formateDuration(dur) {
  const duration = Math.round(dur) || 0
  const minute = padStart(Math.floor(duration / 60),2,'0')
  const second = padStart(duration % 60,2,'0')
  return `${minute}:${second}`
}

// untodo selfdefine
const getCdnHost = () =>
  ENV === 'production'
    ? 'img01.mehiya.com'
    : 'me-media-gateway.srv.test.ixiaochuan.cn'

function getImgUrl(img,size) {
  if(img.signurl) {
    return img.signurl
  }
  return `//${getCdnHost()}/img/view/id/${img.id}${size ? `/sz/${size}` : ''}`
}

function request({url,method = 'POST',params = {},timeout = 0}) {
  const p1 = new Promise(async (resolve) => {
    const response = await fetch(url,{
      method,
      body: JSON.stringify(params),
    })
    const body = await response.json()
    resolve(body)
  })
  p1.catch(() => {})

  const promises = [p1]
  if(timeout) {
    const p2 = new Promise((resolve,reject) => {
      setTimeout(() => reject(new Error('timeout')),timeout)
    })
    p2.catch(() => {})
    promises.push(p2)
  }

  return Promise.race(promises)
}

function isNode() {
  return typeof window === 'undefined'
}

function isPhone(phone) {
  return /^[0-9]{1,14}$/.test(phone)
}

function isMobilePhone(phone) {
  return /^1[3|4|5|7|8][0-9]{9}$/.test(phone)
}

const DefaultAvatar = '//img01.icocofun.com/img/view/id/40319962008'
function getDefAvatar() {
  return `${HostMaps.prod.img01}/img/png/id/368398417271`
}
// http://img01.icocofun.com/img/view/id/40319962008
function getAvatarUrl(avatarId,size = 228) {
  // 1 - male, 2 - female
  if(!avatarId || avatarId === 1 || avatarId === 2) {
    return getDefAvatar()
  }
  return `//${getCdnHost()}/account/avatar/id/${avatarId}/sz/${size}`
}

const getAvatorImgByMember = (member,size) => {
  if(!member) {
    return getDefAvatar()
  }
  return (
    deepGet(member,'avatarUrls.aspectLow.urls.0','') ||
    getAvatarUrl(member.avatar,size)
  )
}
const avatarImgError = (e) => {
  e.target.src = getDefAvatar()
}

const openUser = (id) => {
  if(!id) {
    return
  }
  window.HiyaJSBridge.callHandler('openScheme',{
    url: `hiya://openUser?uid=${id}`,
  })
}
const openChat = (id,operationtType = 1) => {
  if(!id) {
    return
  }
  window.HiyaJSBridge.callHandler('openScheme',{
    url: `hiya://openChat?uid=${id}&operationtType=${operationtType}`,
  })
}
const openFamily = (id) => {
  if(!id) {
    return
  }
  // 打开family页面
  window.HiyaJSBridge.callHandler('openScheme',{
    url: `hiya://openFamily?from=web&fid=${id}`,
  })
}
const openStore = (tab = 0) => {
  // 打开商店页面
  window.HiyaJSBridge.callHandler('openScheme',{
    url: `hiya://openStore?tab=${tab}`,
  })
}

const openCreateFamily = () => {
  window.HiyaJSBridge.callHandler('openScheme',{
    url: `hiya://openCreateFamily`,
  })
}

const openRoom = (id) => {
  if(!id) {
    return
  }
  window.HiyaJSBridge.callHandler('openScheme',{
    url: `hiya://openRoom?room_id=${id}&from=web`,
  })
}

const createRoom = () => {
  // 创建房间
  window.HiyaJSBridge.callHandler('openScheme',{
    url: `hiya://openCreateRoom`,
  })

}
const formatTime2Arr = (t = 0,returnDay = true) => {
  // returnDay === false 无需去取天数的余数 数据驱动
  const rule = returnDay ? [24,60,60] : [60,60]
  let result = []
  let theTime = parseInt(t,10)
  while(rule.length > 0) {
    const r = rule.pop()
    const n = theTime % r
    result.push(n > 9 ? `${n}` : `0${n}`)
    theTime = Math.floor(theTime / r)
    if(rule.length === 0)
      result.push(theTime > 9 ? `${theTime}` : `0${theTime}`)

  }
  if(!returnDay) {
    // 维持之前formatTime2Arr的返回值slice(1)的习惯
    result.push('00')
  }
  // returnDay === true [天, 时, 分, 秒] returnDay === false [0 ,时, 分, 秒]
  result = result.reverse()
  return result
}

const formatBigNum = (num,toFixed = 2,maxNum = 0) => {
  const nten = Math.pow(10,toFixed)
  // 当maxNum传了，并且num大于maxNum的时候才会去格式化，否则直接返回num
  if(maxNum && num <= maxNum) {
    return num
  }
  const million = 1000000
  const kilo = 1000
  if(num >= million) {
    // *1 去掉为0的小数位  向下取整数
    return `${Math.floor(num * nten / million ) / nten * 1}M`
  }
  if(num >= kilo) {
    // *1 去掉为0的小数位
    return `${Math.floor(num * nten / kilo ) / nten * 1}k`
  }
  return `${num}`
}

const selectImages = (params = {}) => {
  const imgSrc =
    ENV === 'production'
      ? `http://img01.mehiya.com/img/png/id/`
      : `http://me-media-gateway.srv.test.ixiaochuan.cn/img/png/id/`
  return new Promise((res) => {
    window.HiyaJSBridge.callHandler('selectImages',params,({imageIds}) => {
      res(imageIds.map((v) => imgSrc + v))
    })
  })
}

// 老仓库环境区分
const oldRepositoryOrigin = () => {
  return HostMaps.auto.websit
}
// 获取当前环境
const getEnv = () => {
  return ENV
}

export const getRankListId = (key,area,obj) => {
  return obj[getEnv() === 'production' ? 'prod' : 'test'][area][key]
}
export const getChineseArea = (
  areaList,
  areaCode,
  areaChinese,
  defaultAreaCode = 0
) => {
  // 返回翻译中的地域名称缩写
  // 没有就返回默认的code
  const inRange = areaList.some((code) => code === areaCode)
  return areaChinese[inRange ? `${areaCode}` : `${defaultAreaCode}`]
}

const getElCenter = (el) => {
  if(el && el.getBoundingClientRect) {
    const elRect = el.getBoundingClientRect()
    return {
      x: elRect.x + elRect.width / 2,
      y: elRect.y + elRect.height / 2,
      left: el.scrollLeft,
      top: el.scrollTop,
    }
  }
  return {
    x: el.innerWidth / 2,
    y: el.innerHeight / 2,
    left: el.scrollX,
    top: el.scrollY,
  }
}
/**
 *  滚动 parent 使 el 剧中
 * @param {*} parent 父滚动元素|window对象
 * @param {*} el  要居中元素
 * @param {*} type x｜y
 * @param {*} isAr  阿语 transform: scaleX(-1) 布局兼容
 */
const scrollCenter = ({parent = window,el,type = 'y',isAr = false}) => {
  const map = {
    x: 'left',
    y: 'top',
  }
  const mapValue = map[type]
  const elRect = getElCenter(el)
  const parentRect = getElCenter(parent)
  // 阿语 transform: scaleX(-1) 布局兼容
  const prefix = type === 'x' && isAr ? -1 : 1
  parent.scrollTo({
    [mapValue]:
      prefix * (elRect[type] - parentRect[type]) + parentRect[mapValue],
    behavior: 'smooth',
  })
}
export const getAreaData = (areaCode,area_objs,defaultAreaCode = 0) => {
  return area_objs[areaCode] ? area_objs[`${areaCode}`] : area_objs[`${defaultAreaCode}`]
}
export function getSize1(size) {
  return `${size / 3.75}vw`
}
export function getBackground(img) {
  return `url(${replaceAutoHost(img)}) no-repeat center / 100% 100%`;
}
// 将数组变成tabBtns需要的key和数据结构
export const mapArrToTab = (strList) => {
  return strList.map((v,i) => {
    const temp = {}
    temp.key = i + 1
    temp.textList = [`${v}`]
    return temp
  })
}
const compareVersion = (v1 = '0',v2 = '0') => {
  const spliter = '.'
  const version1 = v1.split(spliter)
  const version2 = v2.split(spliter)

  const len = Math.max(version1.length,version2.length)

  const vs1 = [...version1,...Array(len - version1.length).fill(0)]
  const vs2 = [...version2,...Array(len - version2.length).fill(0)]

  for(let i = 0;i < len;) {
    const part1 = parseInt(vs1[i],10)
    const part2 = parseInt(vs2[i],10)
    if(part1 > part2) {
      return true
    }
    if(part1 < part2) {
      return false
    }

    i += 1
  }

  return true
}
// 判断某个元素是否在视窗中
const isInViewPort = (element) => {
  const viewWidth = window.innerWidth || document.documentElement.clientWidth
  const viewHeight =
    window.innerHeight || document.documentElement.clientHeight
  const {top,right,bottom,left} = element.getBoundingClientRect()

  return top >= 0 && left >= 0 && right <= viewWidth && bottom <= viewHeight
}
const isNotCompleteNumber = (numStr) => {
  return (
    Number.isNaN(Number(numStr)) ||
    numStr === '' ||
    numStr === null ||
    (numStr && numStr.indexOf('.') === numStr.length - 1)
  )
}

// 数字转成 00,000,000 格式
const TransfarmStringNumber = (num) => {
  if(typeof num === 'number' && num < 100000000 && num >= 0) {
    // 前置补位数组 最多补9位
    const numarr = ['','0','00','00,','00,0','00,00','00,000','00,000,','00,000,0','00,000,00']
    // 利用tolocalstring实现
    const endStr = Math.floor(num).toLocaleString() // 1-10
    const benginStr = numarr[10 - endStr.length] // 0 - 9
    return `${benginStr}${endStr}`
  } else if(num >= 100000000) {
    return '99,999,999'
  } else {
    return '00,000,000'
  }
}

// 一定保留两位小数并向下取整 仅支持number类型
const fixTwoNum = (num) => {
  if (typeof num === 'number') {
    // 使用 Math.round(num * 100) / 100 来四舍五入保留两位小数
    return (Math.round(num * 100) / 100).toFixed(2);
  } else {
    // 处理非数字类型的输入，你可以返回适当的默认值
    return '0';
  }
};

function loadJS(resource,done) {
  if(!resource) {
    console.warn('no resource input')
  } else {
    const node = document.createElement('script')
    node.async = false
    node.src = resource
    const supportOnload = 'onload' in node
    if(supportOnload) {
      node.onload = done
      node.onerror = () => {
        console.error(`${resource}加载失败`,node)
      }
    } else {
      node.onreadystatechange = () => {
        if(/loaded|complete/i.test(node.readyState)) {
          done.call(node)
        }
      }
    }

    document.getElementsByTagName('head')[0].appendChild(node)
  }
}

function multiRequest(arr,max,cb) {
  let count = 0
  const fetchArr = []
  let i = 0
  function toFetch() {
    if(i === arr.length) {
      return Promise.resolve()
    }
    const one = arr[i++]()
    one.then(() => {
      count++
      cb && cb(parseInt((count / arr.length) * 100))
      fetchArr.splice(fetchArr.indexOf(one),1)
    })
    fetchArr.push(one)
    let p = Promise.resolve()
    if(fetchArr.length >= max) {
      p = Promise.race(fetchArr)
    }
    return p.then(() => toFetch())
  }
  toFetch()
    .then(() => Promise.all(fetchArr))
    .then(() => {
      cb && cb(100)
    })
}

const getImgPromises = (keys) => {
  return _map(
    keys,
    (src) => () =>
      new Promise((resolve) => {
        const img = new Image()
        img.src = src
        img.onload = () => {
          resolve('')
        }
        img.onerror = () => {
          resolve('')
        }
      })
  )
}
const sleep = (s) => {
  return new Promise((res) => {
    setTimeout(() => {
      res(null)
    },s)
  })
}

const createFindImg = (rewarsPng) => (str) => {
  const src = rewarsPng.keys().find((v) => {
    return v.indexOf(str) !== -1
  })
  return src && rewarsPng(src)
}

function roundFun(value, n) {
  return Math.round(value*Math.pow(10,n))/Math.pow(10,n);
}

/**
 * 将传入的数字（num）转换成指定长度（digit）的字符串数组，可选插入千分位逗号
 */
function formatDigitNum({ digit, num, useComma = false }) {
  let isNegative = false;
  num = Number(num);
  
  if (isNaN(num)) return [];

  if (num < 0) {
    isNegative = true;
    num = Math.abs(num);
  }

  let numStr = String(num);
  // 补零
  numStr = numStr.padStart(digit, '0');

  if (useComma) {
    // 添加千分位逗号
    numStr = numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  if (isNegative) {
    numStr = '-' + numStr;
  }

  return numStr.split('');
}


function formatNumber(num = 0) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function write(input = '') {
  const el = document.createElement('textarea')

  el.value = input

  // Prevent keyboard from showing on mobile
  el.setAttribute('readonly', '')

  el.style.contain = 'strict'
  el.style.position = 'absolute'
  el.style.left = '-9999px'
  el.style.fontSize = '12pt' // Prevent zooming on iOS

  const selection = document.getSelection()
  let originalRange = false
  if (selection.rangeCount > 0) {
    originalRange = selection.getRangeAt(0)
  }

  document.body.appendChild(el)
  el.select()

  // Explicit selection workaround for iOS
  el.selectionStart = 0
  el.selectionEnd = input.length

  let success = false
  try {
    success = document.execCommand('copy')
  } catch (err) {
    //
  }

  document.body.removeChild(el)

  if (originalRange) {
    selection.removeAllRanges()
    selection.addRange(originalRange)
  }

  return success
}

const transNumber = (num = 0, padZeroNum = 0) => {
  let res = Number.isNaN(num) ? '' : num?.toString()
  if (padZeroNum) {
    const pad = new Array(padZeroNum).fill(0).join('')
    res = `${pad}${res}`.slice(-padZeroNum)
  }
  return res?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

/**
 * 是否是全屏打开（H5 页面是否铺满整个屏幕）
 */
const isFullscreenMode = (h_web_top) => {
  const screenHeight = window.screen.height; // 整个窗口大小
  const viewHeight = window.visualViewport?.height || window.innerHeight; // 可视窗口大小
  return Boolean(screenHeight <=  (viewHeight+Number(h_web_top || 0)))
}


export {
  formatNumber,
  avatarImgError,
  compareVersion,
  formatBigNum,
  formateDuration,
  formatTime2Arr,
  getAvatarUrl,
  getAvatorImgByMember,
  getEnv,
  getImgUrl,
  isMobilePhone,
  isNode,
  isPhone,
  oldRepositoryOrigin,
  openCreateFamily,
  openFamily,
  openUser,
  openRoom,
  padStart,
  request,
  scrollCenter,
  selectImages,
  openStore,
  isInViewPort,
  isNotCompleteNumber,
  fixTwoNum,
  TransfarmStringNumber,
  loadJS,
  openChat,
  multiRequest,
  getImgPromises,
  sleep,
  createRoom,
  createFindImg,
  roundFun,
  formatDigitNum,
  write,
  transNumber,
  isFullscreenMode,
}
